import React, { useState, useEffect } from 'react';
import { useContent } from '../../contexts/ContentContext';
import ImageUpload from './ImageUpload';
import './ThreeBlocksAdmin.css';

const ThreeBlocksAdmin = ({ contentPath }) => {
  const { getContent, updateContent } = useContent();
  const [sectionData, setSectionData] = useState(null);

  useEffect(() => {
    const data = getContent(contentPath);
    setSectionData(data);
  }, [contentPath, getContent]);

  const handleBlockUpdate = (block, field, value) => {
    updateContent(`${contentPath}.${block}.${field}`, value);
    setSectionData(getContent(contentPath));
  };

  if (!sectionData) {
    return (
      <div className="three-blocks-admin-loading">
        <i className="fas fa-spinner fa-spin"></i>
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <div className="three-blocks-admin">
      <div className="admin-section-header">
        <div className="section-info">
          <h2>
            <i className="fas fa-book-open"></i>
            Histoire, Vision & Mission
          </h2>
          <p>Gérez les 3 blocs principaux de la page À propos (image + texte simple)</p>
        </div>
      </div>

      {/* Notre Histoire */}
      <div className="block-section">
        <div className="block-section-header">
          <h3><i className="fas fa-history"></i> Notre Histoire</h3>
        </div>
        
        <div className="form-grid">
          <div className="form-group">
            <label>Icône (optionnel)</label>
            <input
              type="text"
              value={sectionData.histoire?.icon || ''}
              onChange={(e) => handleBlockUpdate('histoire', 'icon', e.target.value)}
              placeholder="fas fa-history"
            />
          </div>

          <div className="form-group full-width">
            <label>Image</label>
            <ImageUpload
              value={sectionData.histoire?.image}
              onChange={(url) => handleBlockUpdate('histoire', 'image', url)}
              label="Télécharger une image"
            />
          </div>

          <div className="form-group full-width">
            <label>Titre</label>
            <input
              type="text"
              value={sectionData.histoire?.title || ''}
              onChange={(e) => handleBlockUpdate('histoire', 'title', e.target.value)}
              placeholder="Notre Histoire"
            />
          </div>

          <div className="form-group full-width">
            <label>Sous-titre</label>
            <input
              type="text"
              value={sectionData.histoire?.subtitle || ''}
              onChange={(e) => handleBlockUpdate('histoire', 'subtitle', e.target.value)}
              placeholder="L'aventure DentoXcellence..."
            />
          </div>

          <div className="form-group full-width">
            <label>Description</label>
            <textarea
              value={sectionData.histoire?.intro || ''}
              onChange={(e) => handleBlockUpdate('histoire', 'intro', e.target.value)}
              placeholder="DentoXcellence est né d'une vision partagée..."
              rows={6}
            />
          </div>
        </div>
      </div>

      {/* Notre Vision */}
      <div className="block-section">
        <div className="block-section-header">
          <h3><i className="fas fa-eye"></i> Notre Vision</h3>
        </div>
        
        <div className="form-grid">
          <div className="form-group">
            <label>Icône (optionnel)</label>
            <input
              type="text"
              value={sectionData.vision?.icon || ''}
              onChange={(e) => handleBlockUpdate('vision', 'icon', e.target.value)}
              placeholder="fas fa-eye"
            />
          </div>

          <div className="form-group full-width">
            <label>Image</label>
            <ImageUpload
              value={sectionData.vision?.image}
              onChange={(url) => handleBlockUpdate('vision', 'image', url)}
              label="Télécharger une image"
            />
          </div>

          <div className="form-group full-width">
            <label>Titre</label>
            <input
              type="text"
              value={sectionData.vision?.title || ''}
              onChange={(e) => handleBlockUpdate('vision', 'title', e.target.value)}
              placeholder="Notre Vision"
            />
          </div>

          <div className="form-group full-width">
            <label>Sous-titre</label>
            <input
              type="text"
              value={sectionData.vision?.subtitle || ''}
              onChange={(e) => handleBlockUpdate('vision', 'subtitle', e.target.value)}
              placeholder="Vers l'excellence dentaire de demain"
            />
          </div>

          <div className="form-group full-width">
            <label>Description</label>
            <textarea
              value={sectionData.vision?.ambition?.description || ''}
              onChange={(e) => handleBlockUpdate('vision', 'ambition.description', e.target.value)}
              placeholder="Être le référent incontournable de la formation dentaire avancée..."
              rows={6}
            />
          </div>
        </div>
      </div>

      {/* Notre Mission */}
      <div className="block-section">
        <div className="block-section-header">
          <h3><i className="fas fa-bullseye"></i> Notre Mission</h3>
        </div>
        
        <div className="form-grid">
          <div className="form-group">
            <label>Icône (optionnel)</label>
            <input
              type="text"
              value={sectionData.mission?.icon || ''}
              onChange={(e) => handleBlockUpdate('mission', 'icon', e.target.value)}
              placeholder="fas fa-bullseye"
            />
          </div>

          <div className="form-group full-width">
            <label>Image</label>
            <ImageUpload
              value={sectionData.mission?.image}
              onChange={(url) => handleBlockUpdate('mission', 'image', url)}
              label="Télécharger une image"
            />
          </div>

          <div className="form-group full-width">
            <label>Titre</label>
            <input
              type="text"
              value={sectionData.mission?.title || ''}
              onChange={(e) => handleBlockUpdate('mission', 'title', e.target.value)}
              placeholder="Notre Mission"
            />
          </div>

          <div className="form-group full-width">
            <label>Sous-titre</label>
            <input
              type="text"
              value={sectionData.mission?.subtitle || ''}
              onChange={(e) => handleBlockUpdate('mission', 'subtitle', e.target.value)}
              placeholder="Former les dentistes de demain"
            />
          </div>

          <div className="form-group full-width">
            <label>Description</label>
            <textarea
              value={sectionData.mission?.description || ''}
              onChange={(e) => handleBlockUpdate('mission', 'description', e.target.value)}
              placeholder="Notre mission est de..."
              rows={6}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThreeBlocksAdmin;

